import React from 'react'
import PropTypes from 'prop-types';
import RightArrowIcon from "../icons/rightArrowIcon";

const CustomSelect = (props) => {
    const {disabled, multiple} = props;
    const options = props.options ? [...props.options] : [];
    return (
        <div className={"custom-select-wrapper"}>
            <select
                multiple={multiple}
                disabled={disabled}
                onChange={props.onChange}
                className={'custom-select'}
                value={props.value}
                name={props.name}
                required={props.required}
            >
                {
                    options.map(option => {
                        return (
                            <option
                                key={option.key}
                                value={option.key}
                            >
                                {option.value}
                            </option>
                        )
                    })
                }
            </select>
            <button className="btn custom-select-btn form-control buttonPicker">
                <div className={"icon icon-arrow"}>
                    <RightArrowIcon/>
                </div>
            </button>
        </div>
    )
};

CustomSelect.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    required: PropTypes.bool,
    options: PropTypes.array,
};

export default CustomSelect;